import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  Users,
  UserCircle,
  LogOut,
  ClipboardList,
  CreditCard,
  Calendar,
  Receipt,
  Star
} from 'lucide-react';

const AdminSidebar = () => {
  const location = useLocation(); // Ottieni il percorso corrente

  // Funzione helper per determinare se un link è attivo
  const isActive = (path) => location.pathname.includes(path);

  return (
    <nav className="mt-6">
      <Link
        to="/admin/dashboard"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/dashboard')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <Home className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Dashboard</span>
      </Link>

      <Link
        to="/admin/survey/questions"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/survey/questions')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <ClipboardList className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Gestione Questionario</span>
      </Link>

      <Link
        to="/admin/doctors"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/doctors')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <Users className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Gestione Professionisti</span>
      </Link>

      <Link
        to="/admin/patients"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/patients')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <UserCircle className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Gestione Pazienti</span>
      </Link>

      <Link
        to="/admin/payments"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/payments')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <CreditCard className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Gestione Pagamenti</span>
      </Link>

      <Link
        to="/admin/appointments"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/appointments')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <Calendar className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Gestione Appuntamenti</span>
      </Link>

      <Link
        to="/admin/billing"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/billing')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <Receipt className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Rendicontazione</span>
      </Link>


      <Link
        to="/admin/feedbacks"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/admin/feedbacks')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <Star className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Gestione Feedback</span>
      </Link>


      <Link
        to="/logout"
        className={`flex items-center px-4 py-2 transition-colors ${isActive('/logout')
          ? 'bg-purple-100 text-purple-700'
          : 'hover:bg-purple-100 text-gray-700'
          }`}
      >
        <LogOut className="w-5 h-5 mr-3" />
        <span className="text-lg font-medium">Logout</span>
      </Link>

    </nav>
  );
};

export default AdminSidebar;